import '../css/Modal.css';
import '../css/ExternalBrowserGuideModal.css';
import BrowserTopBarMock from './BrowserTopBarMock';
import BrowserMenuMock from './BrowserMenuMock';
import { getInAppBrowserAppName } from '../utils/inAppBrowserUtil';
import {
  EXTERNAL_BROWSER_GUIDE_TITLE,
  EXTERNAL_BROWSER_GUIDE_INTRO,
  EXTERNAL_BROWSER_GUIDE_STEPS,
  EXTERNAL_BROWSER_GUIDE_DONE_LABEL,
} from '../constants/bookingConst';

/**
 * Step-by-step guide to leaving Facebook's / Messenger's in-app browser by
 * hand: (1) tap ••• at the top right, (2) choose "Open in external browser",
 * each with a picture of that part of the screen and a marker on the spot.
 *
 * Opens over the "Open in Your Browser" popup when its button could not hand
 * the page over (see watchExternalBrowserHandoff), or from the popup's help
 * card. Closes only from × or "Got it" — not from a tap outside (CLAUDE.md >
 * Behavior) — and returns the guest to the popup underneath.
 *
 * @param {object} props
 * @param {() => void} props.onClose - closes the guide
 * @param {string} [props.appName] - overrides the app name read from the
 *   user agent (the UI preview page uses it to show either app)
 * @returns {JSX.Element}
 */
function ExternalBrowserGuideModal({ onClose, appName: appNameOverride }) {
  const appName = appNameOverride || getInAppBrowserAppName();
  const host = window.location.host;

  return (
    <div className="modal-overlay ebg-overlay">
      <div className="ebg-card" role="dialog" aria-modal="true" aria-labelledby="ebg-title">
        <button type="button" className="modal-close ebg-close" onClick={onClose} aria-label="Close">×</button>

        <h2 id="ebg-title" className="ebg-title">{EXTERNAL_BROWSER_GUIDE_TITLE}</h2>
        <p className="ebg-intro">{EXTERNAL_BROWSER_GUIDE_INTRO}</p>

        <ol className="ebg-steps">
          <li className="ebg-step">
            <div className="ebg-step-head">
              <span className="ebg-step-number">1</span>
              <span className="ebg-step-text">{EXTERNAL_BROWSER_GUIDE_STEPS.MENU}</span>
            </div>
            <BrowserTopBarMock appName={appName} host={host} />
          </li>
          <li className="ebg-step">
            <div className="ebg-step-head">
              <span className="ebg-step-number">2</span>
              <span className="ebg-step-text">{EXTERNAL_BROWSER_GUIDE_STEPS.OPEN}</span>
            </div>
            <BrowserMenuMock />
          </li>
        </ol>

        <button type="button" className="ebg-done" onClick={onClose}>
          {EXTERNAL_BROWSER_GUIDE_DONE_LABEL}
        </button>
      </div>
    </div>
  );
}

export default ExternalBrowserGuideModal;
